import Pickr from "@simonwep/pickr";
import TrieSearch from "trie-search";

document.addEventListener("alpine:init", () => {
  Alpine.data("optionController", (option, formName, formValue) => ({
    option: {},
    formName: "",
    formValue: "",
    colorPicker: null,
    showList: false,

    searcher: null,
    searchResults: [],
    selectedResult: -1,

    init() {
      if (option.default === undefined) {
        option.default = "";
      }

      this.option = option;
      this.formName = formName;
      this.formValue = formValue;

      if (option.kind === "color") {
        this.colorPicker = createColorPicker(formName);
        this.colorPicker.on(
          "save",
          function(color) {
            if (color) {
              document.getElementById(formName).value = color
                .toHEXA()
                .toString();
            } else {
              document.getElementById(formName).value = "";
            }
            this.colorPicker.hide();
          }.bind(this),
        );
      }

      if (Array.isArray(option.list) && option.list.length > 0) {
        this.searcher = new TrieSearch();
        option.list.forEach((val) => this.searcher.map(val, val));
      }
    },

    reset() {
      let el = document.getElementById(formName);

      switch (option.kind) {
        case "color":
          el.value = this.option.default;
          this.colorPicker.setColor(this.option.default || null);
          break;

        case "checkbox":
          el.checked = this.option.default === "true";
          break;

        default:
          el.value = this.option.default;
      }
    },

    resetText() {
      return this.option.default ? "Reset to default value" : "Clear value";
    },

    refreshResults() {
      const results = this.searcher.search(this.$refs.input.value);
      this.searchResults = results;
      this.selectedResult = results.length ? 0 : -1;
    },

    resultSelected(_index, text) {
      this.$refs.input.value = text;
      this.refreshResults();
    },

    typeahead: {
      ["x-on:focus"]() {
        this.showList = true;
      },
      ["x-on:blur"](e) {
        this.showList = false;

        const related = e.relatedTarget;
        if (related && related.dataset.searchindex !== undefined) {
          this.resultSelected(
            related.dataset.searchindex,
            related.dataset.searchvalue,
          );
        }
      },
      ["x-on:input"](e) {
        this.refreshResults();
      },
      ["x-on:keydown.enter"](e) {
        if (this.selectedResult === -1) return;

        const targetVal = this.searchResults[this.selectedResult];
        if (e.target.value === targetVal) return;

        e.preventDefault();
        e.target.value = targetVal;
      },
      ["x-on:keydown.tab"](e) {
        if (this.selectedResult === -1) return;

        const targetVal = this.searchResults[this.selectedResult];
        if (e.target.value === targetVal) return;

        e.preventDefault();
        e.target.value = targetVal;
      },
      ["x-on:keydown.up"](e) {
        const minIndex = this.searchResults.length ? 0 : -1;

        if (minIndex < this.selectedResult) {
          this.selectedResult--;
        } else {
          this.selectedResult = minIndex;
        }
      },
      ["x-on:keydown.down"](e) {
        const maxIndex = this.searchResults.length - 1;

        if (maxIndex > this.selectedResult) {
          this.selectedResult++;
        } else {
          this.selectedResult = maxIndex;
        }
      },
    },
  }));
});

// make the color picker available
function createColorPicker(src) {
  const inputEl = document.getElementById(src);
  const pickerEl = document.getElementById(`${src}-span`);

  return Pickr.create({
    el: pickerEl,
    default: inputEl.value,
    lockOpacity: true,
    theme: "monolith", // or 'monolith', or 'nano'
    closeOnScroll: true,

    components: {
      // Main components
      preview: true,
      opacity: false,
      hue: true,

      // Input / output Options
      interaction: {
        input: true,
        clear: true,
        save: true,
      },
    },
  });
}
